<section class="alarms">
  <ng-container>
    <div [ngClass]="{'global-actions-and-filters': alarms?.list.length > 0 && allowGlobalActions}">
      @if (allowGlobalActions) {
        <div class="table-global-actions-alarms my-10">
          <div>
            <button (click)="goToEvents(null,eUid,true)"
              class="btn btn--primary">
              {{'action.history' | translate}}
            </button>
          </div>
          @if (actionOnAlarms) {
            <div>
              <button [appReadWrite]="FEATURE.SITE_OPERATION" (click)="acknowledgeAllAlarms()"
                [ngClass]="acknowledgingAll ? 'btn btn--outline-main-color' : 'btn btn--primary'">
                {{'action.all_acquit' | translate}}
              </button>
            </div>
          }
          @if (actionOnAlarms) {
            <div>
              <button (click)="openResetAlarmsModal()" class="btn btn--outline-grey-color" disabled="true">
                {{'action.restore' | translate}}
              </button>
            </div>
          }
        </div>
      }
      <div class="">
        <app-filters-table
          [config]="filtersConfig"
          [filterType]="matchingType"
          [newItemFilter]="newItemFilter"
          [filtersList]="$safeNavigationMigration(dataForChildComponent?.body?.filters)"
          (eventEmitter)="eventReceiver($event)">
        </app-filters-table>
      </div>
    </div>
    @if (loadingState | async; as state) {
      <div>
        @if (state === actionState.LOADING) {
          <span class="ui-loading" [model]="{isLoading: true}"></span>
        }
        @if (state === actionState.READY) {
          <div>
            <div class="table-container">
              <div class="ui-table" (eventOnMouseenterRow)="onMouseenterRowEventOfTable($event)"
                (eventOnMouseleaveRow)="onMouseleaveRowEventOfTable($event)" (eventOnClick)="onEventOnClick($event)"
                [tableInput]='table'>
              </div>
            </div>
            @if (!isoldTableView) {
              <div class="ui-paging" [pagingInput]="paging"
                (eventOnClickPrevLink)="eventOnClickPrevLink($event)"
                (eventOnClickNextLink)="eventOnClickNextLink($event)">
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>
</section>
